import axios from "axios";
import { getHomeLinksByCountry } from "./GetHomeLinksByCountryAction";
import {
  addHomeLinkRequested,
  addHomeLinkRequestSucceeded,
  addHomeLinkRequestFailed,
} from "../slices/AddHomeLinkSlice";

const selectedCountry = localStorage.getItem("selectedCountry");

const apiUrl = `${process.env.REACT_APP_BASE_API_URL}/api/Home/AddHomeLink`;

const ApiKey = process.env.REACT_APP_BASE_API_KEY;

const getSelectedCountryId = () => {
  const sessionData = localStorage.getItem("sesion");

  if (!sessionData || !selectedCountry) {
    return null;
  }

  const session = JSON.parse(sessionData);
  const country = (session.rols || [])
    .map((entry) => entry.country)
    .find((item) => item?.countryName === selectedCountry);

  return country?.idcountry ?? null;
};

export const AddHomeLink = (homeLink) => async (dispatch) => {
  try {
    dispatch(addHomeLinkRequested());

    const postData = {
      name: homeLink.name,
      url: homeLink.url,
      imagePath: homeLink.imagePath,
      countryId: Number(getSelectedCountryId()),
    };

    const axiosConfig = {
      headers: {
        ApiKey: ApiKey,
        "Content-Type": "application/json",
      },
    };

    const response = await axios.post(apiUrl, postData, axiosConfig);

    if (response.data === true) {
      dispatch(addHomeLinkRequestSucceeded(response.data));
      await dispatch(getHomeLinksByCountry());
      return { success: true, message: "Home link created successfully" };
    }

    const errorMessage =
      "The home link could not be created. A link with the same name may already exist for this country.";
    dispatch(addHomeLinkRequestFailed(errorMessage));

    return { success: false, message: errorMessage };
  } catch (error) {
    const errorMessage = error.response?.data || error.message;
    dispatch(addHomeLinkRequestFailed(errorMessage));

    return {
      success: false,
      message: errorMessage,
    };
  }
};
